import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/home';

export default function TestimonialsSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-18">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            用户怎么说
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            来自真实用户的使用反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-10">
          {testimonials.map((t) => (
            <div key={t.name} className="p-6 md:p-7 rounded-xl bg-background-50">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-sm font-semibold text-accent-600">{t.avatar}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/about#reputation"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看更多用户评价
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}